import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { COLUMN_MINIMUM_WIDTH } from '../table/constants/sizes';
const LoadingCell = styled.div.attrs({
  'data-test-id': 'loading-cell'
}).withConfig({
  displayName: "LoadingCell",
  componentId: "ac3imw-0"
})(["display:block;height:20px;min-width:", ";background-color:", ";"], COLUMN_MINIMUM_WIDTH, GYPSUM);
export default LoadingCell;